import type { CustomErrorCode } from "@sieg-ad/error/types";
import { Exception } from "@sieg-ad/error";

/**
 * Extrai a mensagem de um erro de API, com fallback.
 * Usa o mesmo texto que o handler global (`error.message`), de modo que o
 * dedup por toastId colapse o toast do catch local com o do handler global.
 */
export const apiMessage = (e: any, fallback: string): string =>
  e?.data?.message ?? e?.message ?? fallback;

export class AbortError extends Exception {
  redirect: string;

  constructor(message: string, redirect: string = '/') {
    const parsedCode = (message.startsWith('SG_') ? message : `SG_${message}`) as CustomErrorCode;

    super(message, { code: parsedCode, status: 500 });
    this.redirect = redirect;
  }
}